import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ResidencePermit  {
    _originalTypeClassName = "zERP.BO.ResidencePermit";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ResidencePermit.translate = translateService;
}
this.Id = null;
this.HasPermit = false;
this.RequiresApproval = false;
this.IsVisa = false;
this.VisaNumber = null;
this.VisaFrom = null;
this.VisaTo = null;
this.PermitGroup = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
HasPermit:any;
RequiresApproval:any;
IsVisa:any;
VisaNumber:any;
VisaFrom:any;
VisaTo:any;
PermitGroup:any;
Type:any;
TypeForApproval:any;
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setTypeForApproval = ($this, value) => {
var oldValue = $this.TypeForApproval;
$this.TypeForApproval = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}